import {
  create_title
} from '@/base/titleData'

export default {
  animateCombObj: {
    value: 0,
    animate: {
      _key: 'none'
    }
  },
  animateType: 'module_animation',
  pc_infor: {
    marginTop: '0',
    marginRight: '0',
    marginBottom: '0',
    marginLeft: '0'
  },
  mb_infor: {
    marginTop: '0',
    marginRight: '0',
    marginBottom: '0',
    marginLeft: '0'
  },
  pc_widgets_infor: {
    title: create_title('Plugin code'),
    height: 100,
    width: 100
  },
  mb_widgets_infor: {
    title: create_title('Plugin code'),
  },
  listArr: {
    type: 'default', // default | head | body
    content: '',
    id: '',
    note:''
  }
}



// WEBPACK FOOTER //
// ./src/widgets/basic_plugin_code/style.js